import messages from '../../../locales/messages';
import {
  ListItem,
  Tile,
  TooltipIcon,
  UnorderedList,
  Link,
} from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import './enterpriseSearch.scss';
import { ArrowRight16, Information16 } from '@carbon/icons-react';
import { img_col1, img_col2 } from '../../../constants/default';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import { segmentsTracking } from 'src/common/lib/tracker';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';

const TextToolTip_col1_01 = () => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <p className="es_tooltipText">
        <span className="es_strongFont">
          {useTranslation('es_col1_tooltip_01_1')}
        </span>
        {useTranslation('es_col1_tooltip_01_2')}
      </p>
    </>
  );
};
const TextToolTip_col1_02 = () => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <p className="es_tooltipText">
        {useTranslation('es_col1_tooltip_02_1')}
        <span className="es_strongFont">
          {useTranslation('es_col1_tooltip_02_2')}
        </span>
        {useTranslation('es_col1_tooltip_02_3')}
      </p>
    </>
  );
};
const TextToolTip_col2_01 = () => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <div>
      <p className="es_tooltipText">{useTranslation('es_col2_tooltip_01_1')}</p>
      <p className="es_tooltipText">{useTranslation('es_col2_tooltip_01_2')}</p>
      <p className="es_tooltipText">{useTranslation('es_col2_tooltip_01_3')}</p>
    </div>
  );
};
const TextToolTip_col2_02 = () => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <p className="es_tooltipText">
        {useTranslation('es_col2_tooltip_02_1')}
        <span className="superIndex">
          {useTranslation('es_col2_tooltip_02_2')}
        </span>
        {useTranslation('es_col2_tooltip_02_3')}
      </p>
    </>
  );
};
const TextToolTip_col2_03 = () => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <p className="es_tooltipText">{useTranslation('es_col2_tooltip_03_1')}</p>
    </>
  );
};
type EnterpriseSearchProps = {
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
export const EnterpriseSearch = ({ setStep }: EnterpriseSearchProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const isSmall = useSmallBreakpoint('560px');
  return (
    <>
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4 es_columns column01">
        <Tile>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <PublicImage
                imgPath={img_col1}
                widgetId="ai-solutions-advisor"
                id="img01"
                alt="AI Solutions Advisor icon picture"
                className="es_imgs"
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody">
                {useTranslation('es_col1_paragraph_01')}
              </p>
              <UnorderedList className="es_textbody es_bulletPoints">
                <ListItem>{useTranslation('es_col1_paragraph_02')}</ListItem>
                <ListItem>{useTranslation('es_col1_paragraph_03')}</ListItem>
                <ListItem>{useTranslation('es_col1_paragraph_04')}</ListItem>
              </UnorderedList>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody es_interline">
                {useTranslation('es_col1_paragraph_05')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody">
                {useTranslation('es_col1_paragraph_06_01')}
                <span className="strongFont">
                  {useTranslation('es_col1_paragraph_06_02')}
                </span>
                <TooltipIcon
                  align="start"
                  direction={isSmall ? 'bottom' : 'top'}
                  renderIcon={Information16}
                  tooltipText={TextToolTip_col1_01()}
                  children={''}
                />
                <span className="strongFont">
                  {useTranslation('es_col1_paragraph_06_03')}
                </span>
                <TooltipIcon
                  align="center"
                  direction={isSmall ? 'bottom' : 'right'}
                  renderIcon={Information16}
                  tooltipText={TextToolTip_col1_02()}
                  children={''}
                />
              </p>
            </div>
          </div>
        </Tile>
      </div>
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4 es_columns es_column02">
        <Tile className="es_tile02">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <PublicImage
                imgPath={img_col2}
                widgetId="ai-solutions-advisor"
                id="img02"
                alt="AI Solutions Advisor icon picture"
                className="es_imgs"
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody">
                {useTranslation('es_col2_paragraph_01')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody es_interline">
                {useTranslation('es_col2_paragraph_02')}
                <TooltipIcon
                  align="center"
                  direction={isSmall ? 'bottom' : 'left'}
                  renderIcon={Information16}
                  tooltipText={TextToolTip_col2_01()}
                  children={''}
                />
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="disclimer">*{useTranslation('disclaimer')}</p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="es_textbody">
                {useTranslation('es_col2_paragraph_03')}
              </p>
              <UnorderedList className="es_textbody es_bulletPoints">
                <ListItem>
                  {useTranslation('es_col2_paragraph_04')}
                  <TooltipIcon
                    align="center"
                    direction={isSmall ? 'bottom' : 'left'}
                    renderIcon={Information16}
                    tooltipText={TextToolTip_col2_02()}
                    children={''}
                  />
                </ListItem>
                <ListItem>
                  {useTranslation('es_col2_paragraph_05')}
                  <TooltipIcon
                    align="start"
                    direction={isSmall ? 'bottom' : 'left'}
                    renderIcon={Information16}
                    tooltipText={TextToolTip_col2_02()}
                    children={''}
                  />
                </ListItem>
                <ListItem>
                  {useTranslation('es_col2_paragraph_06')}
                  <TooltipIcon
                    align="end"
                    direction={isSmall ? 'bottom' : 'left'}
                    renderIcon={Information16}
                    tooltipText={TextToolTip_col2_03()}
                    children={''}
                  />
                </ListItem>
              </UnorderedList>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <Link
                role="button"
                className="bx-link-class es_textbody takeNextSteps"
                id="ee-next-step-id"
                rel="noreferrer"
                renderIcon={() => <ArrowRight16 className="Image" />}
                onClick={() => {
                  console.log('clicking');
                  setStep(2);
                  segmentsTracking('CTA Clicked', {
                    pageTitle: 'AI Solutions Advisor',
                    object: 'AI Solutions Advisor page',
                    resultValue: 'CTA clicked',
                    CTA: 'Take next Step',
                    location: 'Enterprise Search Path',
                    action: '',
                    field: '',
                  });
                }}
              >
                {useTranslation('take_next_step')}
              </Link>
            </div>
          </div>
        </Tile>
      </div>
    </>
  );
};
